import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { config } from './../../config/config';
const { colorConfig } = config();

const Comment = styled.div`
  font-size: 0.8em;
  font-weight: normal;
  color: #444;
  white-space: normal;
  padding-right: 10px;

  &.checked {
    color: #fff;
  }
`;

const Lbl = ({ onClick, label, comment, checked, children, color }) => {
  const styleLabel = {
    flex: 1, whiteSpace: 'nowrap', color: color || colorConfig.main,
    lineHeight: '2em', 
    fontSize: 14, fontFamily: '\'Nunito Sans\', arial'
  };
  if (checked) {
    styleLabel.color = '#fff';
    styleLabel.cursor = 'default';
  }
  return (
    <div onMouseDown={onClick} style={styleLabel}>
      {label}
      <Comment className={checked ? 'checked' : ''}>{comment}</Comment>
      {children}
    </div>);
};

/* eslint-disable jsx-a11y/label-has-for */
export const RadioSolidButton = ({ minWidth, value, label, comment, children, checked, onChange, color }) => {
  const onClick = () => { onChange(value); };
  const styleTop = {
    display: 'flex', alignContent: 'center', alignItems: 'flex-start', padding: '0px 0px', cursor: 'pointer',
    userSelect: 'none', margin: 0, minWidth: minWidth || 80
  };
  styleTop.minWidth = '150px'
  styleTop.marginRight = '10px'
  styleTop.textAlign = 'center'
  if (checked) {
    styleTop.background = '#86b42d';
    styleTop.borderRadius = 0;
    styleTop.color = "#fff";
  } else {
    styleTop.border = '1px #86b42d solid';
  }
  return (
    <label className='radioButton' style={styleTop}>
      <Lbl {...{ onClick, label, comment, children, checked, color }} />
    </label>
  );
};

RadioSolidButton.propTypes = {
  onChange: PropTypes.func.isRequired
};

export default RadioSolidButton;



// WEBPACK FOOTER //
// ./src/components/Form/RadioSolidButton.js